import Store from '@/store/'
/**
 * 登录
 * @param {*} vm this
 * @param {*} userForm 用户信息
 */
export async function userLogin (vm, userForm) {
  return (await vm.$http.post('/user/login', {
    username: userForm.username,
    password: userForm.password
  })).data
}
/**
 * 所有启用的组织
 * @param {*} vm this
 */
export async function allOnAssociation (vm, search) {
  const res = (await vm.$http.post('/association/allOn', {
    search
  })).data
  const data = res.data
  data.unshift({
    name: '上海市房地产估价师协会',
    channel: '0',
    id: '-999'
  })
  Store.store('using_association', data)
  return Store.store('using_association')
}
/**
 * 所有停用的组织
 * @param {*} vm  this
 */
export async function allOffAssociation (vm, search) {
  const res = (await vm.$http.post('/association/allOff', {
    search
  })).data
  Store.store('stoped_association', res.data)
  return Store.store('stoped_association')
}
/**
 * 添加协会组织
 * @param {*} vm this
 * @param {*} form 组织表单
 */
export async function addAssociation (vm, form) {
  const res = (await vm.$http.post('/association/add', {
    name: form.name,
    validityPeriod: form.validityPeriod
  })).data
  // await allOnAssociation(vm)
  return res
}

/**
 * 修改协会
 * @param {*} vm this
 * @param {*} id 协会id
 * @param {*} update  需要修改的字段及其新的值
 */
export async function editAssociation (vm, id, update) {
  const res = (await vm.$http.post('/association/edit', {
    id,
    update
  })).data
  // await allOnAssociation(vm)
  return res
}
/**
 * 启用协会
 * @param {*} vm this
 * @param {*} id 协会id
 * @param {*} update  需要修改的字段及其新的值
 */
export async function enAbleAssociation (vm, id, validityPeriod) {
  const update = {
    state: 1,
    validityPeriod
  }
  const res = (await vm.$http.post('/association/edit', {
    id,
    update
  })).data

  // await allOnAssociation(vm)
  // await allOffAssociation(vm)
  return res
}
/**
 * 用户列表
 * @param {*} vm
 * @param {*} filter
 */
export async function allUsers (vm, filter) {
  const res = (await vm.$http.post('/user/all', {
    page: 1,
    limit: 100,
    filter: Object.assign({
      isDelete: 0
    }, filter)
  })).data
  Store.store('users_in_current_channel', res.data.items)
  return res
}
/**
 * 新增组织用户
 * @param {*} vm
 * @param {*} name
 * @param {*} username
 * @param {*} phone
 * @param {*} initPwd
 * @param {*} channel
 */
export async function addUser (vm, form, channel) {
  const res = (await vm.$http.post('/user/add', {
    name: form.name,
    username: form.username,
    phone: form.phone,
    initPwd: form.initPwd,
    editChannel: channel
  })).data
  // allUsers(vm, { channel })
  return res
}

/**
 * 修改组织用户
 * @param {*} vm
 * @param {*} name
 * @param {*} username
 * @param {*} phone
 * @param {*} initPwd
 * @param {*} channel
 */
export async function editUser (vm, form, channel) {
  const res = (await vm.$http.post('/user/edit', {
    name: form.name,
    username: form.username,
    phone: form.phone,
    initPwd: form.initPwd,
    editChannel: channel,
    id: form.id
  })).data
  // allUsers(vm, { channel })
  return res
}

export async function deleteUser (vm, id, channel) {
  const res = (await vm.$http.post('/user/delete', {
    id: id
  })).data
  // allUsers(vm, { channel })
  return res
}

export async function resetPwd (vm, id) {
  const res = (await vm.$http.post('/user/resetPwd', {
    id: id
  })).data
  return res
}

/**
 * 新增用户
 * @param {*} vm
 * @param {*} name
 * @param {*} username
 * @param {*} phone
 * @param {*} initPwd
 * @param {*} channel
 */
export async function addNormal (vm, form, channel) {
  const res = (await vm.$http.post('/user/addNormal', {
    name: form.name,
    username: form.username,
    phone: form.phone,
    initPwd: form.initPwd,
    editChannel: channel
  })).data
  // allUsers(vm, { channel })
  return res
}

/**
 * 修改用户
 * @param {*} vm
 * @param {*} name
 * @param {*} username
 * @param {*} phone
 * @param {*} initPwd
 * @param {*} channel
 */
export async function editNormal (vm, form, channel) {
  const res = (await vm.$http.post('/user/editNormal', {
    name: form.name,
    username: form.username,
    phone: form.phone,
    initPwd: form.initPwd,
    editChannel: channel,
    id: form.id
  })).data
  // allUsers(vm, { channel })
  return res
}

export async function deleteNormal (vm, id, channel) {
  const res = (await vm.$http.post('/user/deleteNormal', {
    id: id
  })).data
  // allUsers(vm, { channel })
  return res
}

export async function mutiEdit (vm, validityPeriod) {
  const res = (await vm.$http.post('/association/editMulti', {
    validityPeriod: validityPeriod
  })).data
  // allOnAssociation(vm)
  // allOffAssociation(vm)
  return res
}

export async function resetPwdNormal (vm, id) {
  const res = (await vm.$http.post('/user/resetPwdNormal', {
    id: id
  })).data
  return res
}

export async function disableAssociation (vm, id) {
  const res = (await vm.$http.post('/association/edit', {
    id,
    update: {
      state: 0
    }
  })).data
  return res
}
